import React, { useState } from "react";
import "./contact.css";
import { FaEnvelope } from "react-icons/fa";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
import { SEND_API } from "../../utils/APIs";
import { RECAPTCHA_SITEKEY } from "../../utils/config";

function Contact() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "Course Enquiry for AI",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCaptchaChange = (value) => {
    setCaptchaVerified(!!value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Please enter your name";
    if (!formData.email.trim()) {
      newErrors.email = "Please enter a valid email address";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Please enter your mobile number";
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Mobile number must be 10 digits";
    }

    if (!formData.message.trim()) newErrors.message = "Please enter a message";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (!captchaVerified) {
      setErrors({ captcha: "Please verify the CAPTCHA." });
      return;
    }

    setIsLoading(true);
    setResponseMessage(""); 

    const formSend = new FormData();
    formSend.append("name", formData.name);
    formSend.append("email", formData.email);
    formSend.append("phone", formData.phone);
    formSend.append("subject", formData.subject);
    formSend.append("message", formData.message);

    try {
      const response = await fetch(`${SEND_API}`, {
        method: "POST",
        mode: "cors", 
        body: formSend,
      });

      if (!response.ok) {
        throw new Error(`HTTP Error! Status: ${response.status}`);
      }

      const result = await response.text();
      console.log("Server Raw Response:", result);


      if (result.toLowerCase().includes("success")) {
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "Course Enquiry for AI",
          message: "",
        });

        navigate("/ai-course-in-chennai/thank-you");
      } else {
        setResponseMessage("Email not sent. Server rejected request.");
      }
    } catch (error) {
     
      console.error("Frontend Fetch Error Details:", error);
      

      setResponseMessage(`Connection failed (${error.message}). Please check console.`);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="contact-container">
      <section className="contact-section">
        <div className="headlines-for-all">



          <h4 data-aos="fade-up" >
            <span>Contact </span> Us
          </h4>
          <p data-aos="fade-up">
            Get in touch with us for course details, career guidance, or any support.
          </p>
        </div>



        <div className="contact-layout-centered">
          <div className="contact-card-wrapper">
            <div className="contact-form-pane">
              <h2 className="form-heading">Send us a message</h2>

              <form onSubmit={handleSubmit} className="form-element">
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Name :</label>
                    <input
                      type="text"
                      name="name"
                      className="form-input"
                      placeholder="Your name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && <p className="error-text">{errors.name}</p>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Email :</label>
                    <input
                      type="email"
                      name="email"
                      className="form-input"
                      placeholder="Your email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <p className="error-text">{errors.email}</p>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Phone :</label>
                    <input
                      type="text"
                      name="phone"
                      className="form-input"
                      placeholder="Phone number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    {errors.phone && <p className="error-text">{errors.phone}</p>}
                  </div>
                  <div className="form-group">
                    <label className="form-label">Subject :</label>
                    <input
                      type="text"
                      name="subject"
                      className="form-input field-disabled"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={handleChange}
                      disabled
                    />
                  </div>
                </div>

                <div className="form-group field-full-width">
                  <label className="form-label">Message :</label>
                  <textarea
                    name="message"
                    className="form-textarea"
                    placeholder="Write your message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                  />
                  {errors.message && <p className="error-text">{errors.message}</p>}
                </div>

                <div className="captcha-container">
                  <ReCAPTCHA
                    sitekey={RECAPTCHA_SITEKEY}
                    onChange={handleCaptchaChange}
                  />
                </div>

                {errors.captcha && <p className="error-text">{errors.captcha}</p>}

                <button type="submit" className="download-btn" disabled={isLoading}>
                  {isLoading ? "SENDING..." : "SEND MESSAGE"}
                </button>

                {responseMessage && (
                  <p className="status-message">{responseMessage}</p>
                )}
              </form>
            </div>

            <div className="contact-info-pane">
              <h3 className="info-heading">Contact Information</h3>
              <p className="info-item">
                <FaLocationDot className="info-icon" /> No:21 Vinayaga Nagar, Okkiyam Thoraipakkam, Chennai 600097.
              </p>
              <p className="info-item">
                <FaPhone className="info-icon" /> +91 6380866249
              </p>
              <p className="info-item">
                <FaEnvelope className="info-icon" /> info@fazoacademy.com
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;